import { AxiosResponse } from 'axios';

import { Contact } from '@/types/contact';
import { Organization } from '@/types/organization';
import { api } from '@/services/api/axios/instance';

type GetListParams = {
  data: {
    organizationId: Organization['id'];
  };
};

type GetParams = {
  data: {
    contactId: Contact['id'];
    organizationId: Organization['id'];
  };
};

type CreateParams = {
  data: {
    contact: Contact;
    organizationId: Organization['id'];
  };
};

type UpdateParams = {
  data: {
    contact: Contact;
    organizationId: Organization['id'];
  };
};

type DeleteParams = {
  data: {
    contactId: Contact['id'];
    organizationId: Organization['id'];
  };
};

export const billingContactsApi = {
  getList: async (config: GetListParams): Promise<Contact[]> => {
    const { organizationId } = config.data;
    const path = `/organizations/${organizationId}/billing_contacts`;

    const response: AxiosResponse<{
      billingContacts: Contact[];
    }> = await api.get(path, config);

    return response.data.billingContacts;
  },
  get: async (config: GetParams): Promise<Contact> => {
    const { organizationId, contactId } = config.data;
    const path = `/organizations/${organizationId}/billing_contacts/${contactId}`;

    const response: AxiosResponse<{
      billingContact: Contact;
    }> = await api.get(path, config);

    return response.data.billingContact;
  },
  create: async (config: CreateParams): Promise<Contact> => {
    const { organizationId, contact } = config.data;
    const path = `/organizations/${organizationId}/billing_contacts`;

    const { id: _id, organizationId: _orgId, ...params } = contact;

    const response: AxiosResponse<{
      billingContact: Contact;
    }> = await api.post(path, params);

    return response.data.billingContact;
  },
  update: async (config: UpdateParams): Promise<Contact> => {
    const { organizationId, contact } = config.data;
    const path = `/organizations/${organizationId}/billing_contacts/${contact.id}`;

    const { id: _id, organizationId: _orgId, ...params } = contact;

    const response: AxiosResponse<{
      billingContact: Contact;
    }> = await api.patch(path, params);

    return response.data.billingContact;
  },
  delete: async (config: DeleteParams): Promise<void> => {
    const { organizationId, contactId } = config.data;
    const path = `/organizations/${organizationId}/billing_contacts/${contactId}`;

    await api.delete(path, config);
  },
};
